export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        _name: "CSidebarNavItem",
        name: "Index",
        to: "/index",
        icon: "cil-speedometer"
      },
      {
        _name: "CSidebarNavTitle",
        _children: ["Router"]
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Router",
        route: "/router",
        icon: "cil-router",
        items: [
          {
            name: "List",
            to: "/router"
          },
          {
            name: "Add",
            to: "/router/add"
          },
          {
            name: "Share Router",
            to: "/router/auth"
          },
          {
            name: "Interfaces",
            to: "/interface/list"
          },
          {
            name: "IP Addresses",
            to: "/ip/list"
          },
          {
            name: "Link IPs",
            to: "/link-ip/list"
          },
          {
            name: "Regions",
            to: "/region/list"
          },
          {
            name: "Router IDs",
            to: "/router-id/list"
          },
        ]
      },
      {
        _name: "CSidebarNavItem",
        name: "Port Forward",
        to: "/port-forward",
        icon: "cil-flight-takeoff"
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Routing",
        route: "/routing",
        icon: "cil-fork",
        items: [
          {
            name: "Filter Chains",
            to: "/routing/filter/chains"
          },
          {
            name: "Router Filters",
            to: "/routing/filter/states"
          },
          {
            name: "Rule Policies",
            to: "/routing/rule/list"
          },
          {
            name: "OSPF",
            to: "/routing/ospf"
          },
          {
            name: "OpenVPN",
            to: "/routing/openvpn/list"
          },
          {
            name: "BGP",
            to: "/routing/bgp/list"
          },
          {
            name: "BGP Endpoints",
            to: "/routing/bgp/endpoint"
          },
          {
            name: "Static Routes",
            to: "/routing/static-route"
          },
          {
            name: "Route Groups",
            to: "/routing/route-group/list"
          },
          {
            name: "Address Lists",
            to: "/routing/address-list"
          }
        ]
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Tunnels",
        route: "/tunnel",
        icon: "cil-layers",
        items: [
          {
            name: "Tunnel List",
            to: "/tunnel/list"
          },
          {
            name: "Endpoints",
            to: "/tunnel/endpoint"
          }
        ]
      },
      {
        _name: "CSidebarNavItem",
        name: "System Logs",
        to: "/system/logs",
        icon: "cil-list"
      },
      {
        _name: "CSidebarNavDropdown",
        name: "CMDB",
        route: "/cmdb",
        icon: "cil-contact",
        items: [
          {
            name: "Device List",
            to: "/cmdb/device"
          },
          {
            name: "Add CMDB Device",
            to: "/cmdb/device/add"
          }
        ]
      },
      {
        _name: "CSidebarNavDropdown",
        name: "DDNS",
        route: "/ddns",
        icon: "cil-casino",
        items: [
          {
            name: "DDNS List",
            to: "/ddns/list"
          },
          {
            name: "Add DDNS Instance",
            to: "/ddns/add"
          },
        ]
      },
      {
        _name: "CSidebarNavTitle",
        _children: ["Account"]
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Setting",
        route: "/user",
        icon: "cil-user",
        items: [
          {
            name: "Info",
            to: "/user/info"
          },
          {
            name: "Domain",
            to: "/user/domain"
          }
        ]
      },
    ]
  }
];